module.exports = __webpack_public_path__ + "static/img/3_4_2.ec32f34c.jpg";